import { render, staticRenderFns } from "./ExampleCarrousel.vue?vue&type=template&id=54520d7e&scoped=true&"
import script from "./ExampleCarrousel.vue?vue&type=script&lang=ts&"
export * from "./ExampleCarrousel.vue?vue&type=script&lang=ts&"
import style0 from "./ExampleCarrousel.vue?vue&type=style&index=0&id=54520d7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54520d7e",
  null
  
)

export default component.exports